module.exports = __webpack_public_path__ + "img/m04.82ddfbde.png";